@if (complianceCheckDetails$ | async; as complianceCheckDetails) {
  <div class="dba-page-top flex h-[100px]">
    <img
      src="https://brainnetsacdn.blob.core.windows.net/content/logo-magnit_tagline_635x229_transparant.svg"
      alt="Magnit"
      title="Magnit"
    />
    <div class="flex position-absolute right-0 align-middle">
      <div class="text-magnit-black pr-10 pt-5">
        <app-date-label [applyStyling]="false"></app-date-label><br />
        {{ complianceCheckDetails!.clientTeamExternalName }}<br />
        <a href="mailto:{{ complianceCheckDetails!.clientTeamEmailAddress }}">{{
          complianceCheckDetails!.clientTeamEmailAddress
        }}</a>
      </div>
    </div>
  </div>

  <div class="mb-5 flex flex-col">
    <h1>{{ 'compliance-check.title' | translate }}</h1>
    @if (
      complianceCheckDetails!.status === 1 ||
      complianceCheckDetails!.status === 2 ||
      complianceCheckDetails!.status === 6
    ) {
      <div class="pl-5 pr-5">
        <p>{{ 'compliance-check.dear' | translate }} {{ complianceCheckDetails!.contactPersonFirstName }},</p>
        <br />
        <p>{{ 'compliance-check.text-1' | translate }}</p>
        <p>{{ 'compliance-check.text-2' | translate }}</p>
        <p>{{ 'compliance-check.text-3' | translate }}</p>
        <br />
        @switch (complianceCheckDetails!.reason) {
          @case (1) {
            <p class="font-bold">{{ 'compliance-check.reason-extension' | translate }}</p>
          }
          @case (2) {
            <p class="font-bold">{{ 'compliance-check.reason-periodically' | translate }}</p>
          }
          @case (3) {
            <p class="font-bold">{{ 'compliance-check.reason-after-start-assignment' | translate }}</p>
          }
        }
        <br />
        <p class="font-bold">{{ 'compliance-check.assignment-details' | translate }}</p>
        <br />
        <div class="card w-lg">
          <div class="card-body flex flex-column lg:flex-row text-gray-dark">
            <div class="columns-lg pr-4 lg:border-r">
              <table>
                <tr>
                  <td class="align-top">
                    <div class="font-bold">{{ 'compliance-check.professional' | translate }}:</div>
                  </td>
                  <td>
                    <div class="pl-4">{{ complianceCheckDetails!.professionalName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="align-top">
                    <div class="font-bold">{{ 'compliance-check.supplier' | translate }}:</div>
                  </td>
                  <td>
                    <div class="pl-4">{{ complianceCheckDetails!.supplierName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="align-top">
                    <div class="font-bold">{{ 'compliance-check.customer' | translate }}:</div>
                  </td>
                  <td>
                    <div class="pl-4">{{ complianceCheckDetails!.customerName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="align-top">
                    <div class="font-bold">{{ 'compliance-check.role' | translate }}:</div>
                  </td>
                  <td>
                    <div class="pl-4">{{ complianceCheckDetails!.functionTitle }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="align-top">
                    <div class="font-bold">{{ 'compliance-check.assignment-number' | translate }}:</div>
                  </td>
                  <td>
                    <div class="pl-4">{{ complianceCheckDetails!.assignmentNumber }}</div>
                  </td>
                </tr>
              </table>
              <br />
              <div class="font-bold">
                <app-period
                  [start]="complianceCheckDetails!.contractStartDate!"
                  [finish]="complianceCheckDetails!.contractEndDate!"
                  [title]="'common.period' | translate"
                  feather="calendar"
                >
                </app-period>
              </div>
            </div>
            <div class="lg:pr-4 lg:pl-4 w-full">
              <div class="mb-1 font-bold">
                {{ 'compliance-check.job-description' | translate }}
              </div>
              <textarea
                readonly
                class="w-full border border-solid"
                spellcheck="false"
                rows="12"
                [innerHTML]="complianceCheckDetails!.jobActivities"
              >
              </textarea>
            </div>
          </div>
        </div>
        <br />
        <p class="font-bold">{{ 'compliance-check.explanation-header' | translate }}</p>
        <p [innerHTML]="'compliance-check.explanation-bullet-points' | translate"></p>
        <p>{{ 'compliance-check.any-questions-contact-us' | translate }}</p>
      </div>
      <br />

      <h2>{{ 'compliance-check.questions.title' | translate }}</h2>
      <div class="w-full">
        <div class="pl-5 pr-5">
          <p>{{ 'compliance-check.confirm-identity.text' | translate }}</p>
          <br />
          <app-choices
            #formFields
            [validationGroup]="requiredGroup"
            [(value)]="questionnaire.isUserOriginalRecipient"
            [title]="
              'compliance-check.confirm-identity.confirmation-text'
                | translate: { contactPersonFirstName: complianceCheckDetails.contactPersonFirstName }
            "
          >
            <app-choice [key]="true" [display]="'common.yes' | translate"> </app-choice>
            <app-choice [key]="false" [display]="'common.no' | translate"> </app-choice>
          </app-choices>
          @if (questionnaire.isUserOriginalRecipient === false) {
            <span [innerHTML]="'compliance-check.confirm-identity.not-original-recipient' | translate"></span>
            <div class="w-[300px] mt-4">
              <app-text-field
                #formFields
                [validationGroup]="requiredGroup"
                [title]="'compliance-check.confirm-identity.first-name' | translate"
                [maxLength]="textFieldMaxLength"
                [(value)]="questionnaire.submitter.firstName"
              >
              </app-text-field>
              <app-text-field
                #formFields
                [validationGroup]="requiredGroup"
                [title]="'compliance-check.confirm-identity.surname' | translate"
                [maxLength]="textFieldMaxLength"
                [(value)]="questionnaire.submitter.surname"
              >
              </app-text-field>
              <app-email-field
                #formFields
                [validationGroup]="emailRequiredGroup"
                [title]="'compliance-check.confirm-identity.email-address' | translate"
                [(value)]="questionnaire.submitter.emailAddress"
              >
              </app-email-field>
            </div>
          }
        </div>
        <hr />
        <!-- Stepper -->
        <mat-stepper
          animationDuration="400"
          orientation="vertical"
          [linear]="false"
          #stepper
          (selectionChange)="onStepChange($event)"
        >
          <ng-template matStepperIcon="edit">
            <mat-icon>done</mat-icon>
          </ng-template>
          <!-- Ask the opening question in case the reason is an extension -->
          @if (isReasonExtension) {
            <mat-step
              [completed]="isExtensionStartSectionCompleted(questionnaire.extensionStartSection)"
              [label]="'compliance-check.questions.extension.section-start.header' | translate"
            >
              <div class="w-full lg:w-[800px]">
                <app-choices
                  #formFields
                  [validationGroup]="requiredGroup"
                  [(value)]="questionnaire.extensionStartSection.willAssignmentBeExtended"
                  [title]="
                    'compliance-check.questions.extension.section-start.question-1'
                      | translate: { contractEndDate: complianceCheckDetails.contractEndDate | localdate: 'mediumDate' }
                  "
                >
                  <app-choice [key]="true" [display]="'common.yes' | translate"> </app-choice>
                  <app-choice [key]="false" [display]="'common.no' | translate"> </app-choice>
                </app-choices>

                @if (questionnaire.extensionStartSection.willAssignmentBeExtended === true) {
                  <app-textarea-field
                    #formFields
                    [validationGroup]="requiredGroup"
                    [title]="'compliance-check.questions.extension.section-start.question-2' | translate"
                    rows="3"
                    [maxLength]="explanationMaxLength"
                    [(value)]="questionnaire.extensionStartSection.expectedEndDateChangedReason"
                  >
                  </app-textarea-field>

                  <div class="w-[240px]">
                    <app-date-picker
                      #formFields
                      [(value)]="questionnaire.extensionStartSection.expectedEndDate"
                      [validationGroup]="requiredGroup"
                      [minDate]="today"
                      [maxDate]="todayThreeYearsLater"
                      [title]="'compliance-check.questions.extension.section-start.question-3' | translate"
                    >
                    </app-date-picker>
                  </div>

                  <app-textarea-field
                    #formFields
                    [validationGroup]="requiredGroup"
                    [title]="'compliance-check.questions.extension.section-start.question-4' | translate"
                    rows="3"
                    [maxLength]="explanationMaxLength"
                    [(value)]="questionnaire.extensionStartSection.deliveriesExplanation"
                  >
                  </app-textarea-field>
                }

                <div>
                  <button type="button" class="btn btn-secondary" matStepperNext>
                    {{ 'compliance-check.questions.next-section' | translate }}
                  </button>
                </div>
              </div>
            </mat-step>
          }
          <!-- If the assignment won't be extended, omit the rest of the questions -->
          @if (isReasonExtension && questionnaire.extensionStartSection.willAssignmentBeExtended === false) {
            <mat-step
              [completed]="questionnaire.hasCompletedTruthfully === true"
              [label]="'compliance-check.questions.section-final.header' | translate"
            >
              <div class="w-full lg:w-[800px]">
                <p>{{ 'compliance-check.questions.section-final.no-further-questions' | translate }}</p>
                <br />
                <app-checkbox
                  #formFields
                  [validationGroup]="mustBeTrueGroup"
                  [(value)]="questionnaire.hasCompletedTruthfully"
                  [title]="'compliance-check.questions.section-final.completed-truthfully' | translate"
                >
                </app-checkbox>
                <br />

                <button type="button" class="btn btn-secondary" matStepperPrevious>
                  {{ 'compliance-check.questions.previous-section' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary ml-3"
                  (click)="submit()"
                  [disabled]="disableSubmitButton()"
                >
                  {{ 'common.send' | translate }}
                </button>
              </div>
            </mat-step>
            <!-- In all other cases, start the corresponding questionnaire based on the reason 
             (extension is currently the 'exceptional' case) -->
          } @else {
            @if (isReasonExtension) {
              <!-- Extension sections -->
              @for (section of questionnaire.extensionSections; track section) {
                <mat-step
                  [completed]="isExtensionSectionCompleted(section)"
                  [label]="'compliance-check.questions.extension.section-' + section.index + '.header' | translate"
                >
                  <div class="w-full lg:w-[800px]">
                    @for (question of section.questions; track question) {
                      <app-textarea-field
                        #formFields
                        [validationGroup]="requiredGroup"
                        [title]="
                          'compliance-check.questions.extension.section-' +
                            section.index +
                            '.question-' +
                            question.index | translate
                        "
                        rows="3"
                        [maxLength]="explanationMaxLength"
                        [(value)]="question.answer"
                      >
                      </app-textarea-field>
                    }

                    <div class="mt-4">
                      <button type="button" class="btn btn-secondary" matStepperPrevious>
                        {{ 'compliance-check.questions.previous-section' | translate }}
                      </button>
                      <button type="button" class="btn btn-secondary ml-3" matStepperNext>
                        {{ 'compliance-check.questions.next-section' | translate }}
                      </button>
                    </div>
                  </div>
                </mat-step>
              }
            } @else {
              <!-- Standard sections -->
              @for (section of questionnaire.standardSections; track section) {
                <mat-step
                  [completed]="isStandardSectionCompleted(section)"
                  [label]="'compliance-check.questions.section-' + section.index + '.header' | translate"
                >
                  <div class="w-full lg:w-[800px]">
                    @for (question of section.questions; track question) {
                      <app-choices
                        #formFields
                        [validationGroup]="requiredGroup"
                        [(value)]="question.answer"
                        [title]="
                          'compliance-check.questions.section-' + section.index + '.question-' + question.index
                            | translate
                        "
                      >
                        <app-choice [key]="true" display="{{ 'common.yes' | translate }}"> </app-choice>
                        <app-choice [key]="false" display="{{ 'common.no' | translate }}"> </app-choice>
                      </app-choices>

                      @if (question.answer === true) {
                        <app-textarea-field
                          #formFields
                          [validationGroup]="requiredGroup"
                          [title]="
                            'compliance-check.questions.section-' +
                              section.index +
                              '.question-' +
                              question.index +
                              '-explanation' | translate
                          "
                          rows="3"
                          [maxLength]="explanationMaxLength"
                          [(value)]="question.explanation"
                        >
                        </app-textarea-field>
                      }
                    }

                    <div class="mt-4">
                      <!-- Hide the 'previous' button in case we're in section 1 and the reason is NOT extension -->
                      @if (section.index === 1 && !isReasonExtension) {
                      } @else {
                        <button type="button" class="btn btn-secondary" matStepperPrevious>
                          {{ 'compliance-check.questions.previous-section' | translate }}
                        </button>
                      }
                      <button type="button" class="btn btn-secondary ml-3" matStepperNext>
                        {{ 'compliance-check.questions.next-section' | translate }}
                      </button>
                    </div>
                  </div>
                </mat-step>
              }
            }

            <!-- Verify and submit -->
            <mat-step
              [completed]="questionnaire.hasCompletedTruthfully === true"
              [label]="'compliance-check.questions.section-final.header' | translate"
            >
              <div class="w-full lg:w-[800px]">
                @if (showAdditionalQuestionWhenAllQuestionsAnsweredNo) {
                  <app-choices
                    #formFields
                    (change)="additionalQuestionAnswered()"
                    [validationGroup]="requiredGroup"
                    [(value)]="questionnaire.hasConfirmedNoChangesToAssignment"
                    title="{{
                      'compliance-check.questions.section-final.additional-question-when-all-questions-answered-no'
                        | translate
                    }}"
                  >
                    <app-choice [key]="true" display="{{ 'common.yes' | translate }}"> </app-choice>
                    <app-choice [key]="false" display="{{ 'common.no' | translate }}"> </app-choice>
                  </app-choices>
                }
                <app-checkbox
                  #formFields
                  [validationGroup]="mustBeTrueGroup"
                  [(value)]="questionnaire.hasCompletedTruthfully"
                  [title]="'compliance-check.questions.section-final.completed-truthfully' | translate"
                >
                </app-checkbox>
                <br />

                <button type="button" class="btn btn-secondary" matStepperPrevious>
                  {{ 'compliance-check.questions.previous-section' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary ml-3"
                  (click)="submit()"
                  [disabled]="disableSubmitButton()"
                >
                  {{ 'common.send' | translate }}
                </button>
              </div>
            </mat-step>
          }
        </mat-stepper>
      </div>
    } @else if (
      complianceCheckDetails!.status === 3 ||
      complianceCheckDetails!.status === 4 ||
      complianceCheckDetails!.status === 5
    ) {
      <app-compliance-check-already-used
        [clientTeamEmailAddress]="complianceCheckDetails.clientTeamEmailAddress!"
      ></app-compliance-check-already-used>
    } @else {
      <app-compliance-check-expired
        [clientTeamEmailAddress]="complianceCheckDetails.clientTeamEmailAddress!"
      ></app-compliance-check-expired>
    }
  </div>
}
